<template>
    <base-page :title="$t('l.owner_manage')" icon="ios-contacts">
        <Row type="flex" justify="end" slot="extra">

            <Col>
                <Button v-if="$ifauth('fun_add_owner')" type="primary" @click="add('modal')">{{$t('l.add_owner')}}
                </Button>
            </Col>
            <Col class="margin-left-5">
                <Button type="primary" @click="refresh">{{$t('l.fresh')}}</Button>
            </Col>
            <Col  class="margin-left-5">
                <Input class="search-keyword" v-model="tableData.page.keyword" search suffix="ios-search"
                       :placeholder="$t('l.remark42')"
                       @on-change="searchBlur"
                       @on-search="getOwner(1)"/>
            </Col>
        </Row>
        <template>
            <Row class="full">
                <Col span="4">
                    <community-tree @change="change"
                                    @onToggleExpand="onToggleExpand"
                                    @onTreeSelect="onTreeSelect"
                                    :current_community="current_community"
                                    :communitys="communitys"
                                    :j_buildings="j_buildings"></community-tree>
                </Col>
                <Col span="20" class="owner-table">
                    <Table @on-select-all="select_all"
                           @on-select="select"
                           @on-select-cancel="select_cancel"
                           @on-select-all-cancel="select_all_cancel"
                           stripe border
                           :loading="tableData.loading"
                           :columns=getColumns
                           :data="tableData.data">
                    </Table>
                    <Row type="flex" justify="center">
                        <Col>
                            <Page size="small"
                                  :current="tableData.page.current"
                                  :page-size="tableData.page.size"
                                  :total="tableData.page.total"
                                  :page-size-opts="tableData.page.sizeOptions"
                                  show-elevator show-sizer show-total
                                  @on-page-size-change="pageSizeChange"
                                  @on-change="getOwner"></Page>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </template>
        <!-- 添加/编辑业主信息 -->
        <lg-modal :title="modal.title" :show="modal.show" :loading="modal.loading"
                  @on-submit="onSubmit('modal','modalKey')"
                  @on-cancel="modal.loading=false; modal.show = false;">
            <Form style="max-height: 400px;overflow-y: auto" :model="modal" :label-width="80" ref="modal"
                  :rules="getFormRules">
                <FormItem :label="$t('l.name')" prop="owner.name">
                    <Input v-model="modal.owner.name"/>
                </FormItem>
                <FormItem :label="$t('l.mobile')" prop="owner.mobile">
                    <Input @on-blur="blur" v-model="modal.owner.mobile"/>
                </FormItem>
                <FormItem :label="$t('l.community')">
                    <Input v-model="current_community.name" disabled/>
                </FormItem>
                <FormItem :label="$t('l.address')">
                    <Row style="display: flex;align-items:center">
                        <Col span="24" style="margin-right: 8px">
                            <Cascader
                                    :value="showChooesdAddress"
                                    ref="mailAddress"
                                    :data="locationTree"
                                    change-on-select
                                    @on-change="(value,selectedData)=>{setOption(value, selectedData)}"
                                    :placeholder="$t('l.build_unit')">
                            </Cascader>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem :label-width="150" :label="$t('l.remark43')">
                    <Row>
                        <i-switch size="small" :value="!!modal.owner.j_admin.length"
                                  @on-change="changeOwnerIsAdmin"></i-switch>
                    </Row>
                </FormItem>
                <p class="explain" style="margin-left: 12px;">注：{{$t('l.explain9')}}</p>
                <FormItem  class="margin-top-10" v-if="modalKey.list.length" :label="$t('l.lift_permission')">
                    <div class="full-x">
                        <Form :show-message="false" ref="modalKey" :model="modalKey" label-position="right"
                              v-for="(item,index) in modalKey.list" :key="index" class="key-form">
                            <!-- 钥匙位置选择 -->
                            <FormItem :prop="'list.'+index+'.chosedAddressKey'"
                                      :rules="{required: true, message: $t('l.remark47'), trigger: 'blur',type:'array',min:1}"
                                      style="display: flex;align-items: center" class="key-form-item"
                                      :label="$t('l.lift_position')">
                                <Cascader
                                        v-model="item.chosedAddressKey"
                                        :data="locationTree"
                                        change-on-select
                                        @on-change="(value,selectedData)=>{onLocationSelectKey(value, selectedData,index)}"
                                        :placeholder="$t('l.remark44')">
                                </Cascader>
                            </FormItem>
                            <!-- 业主钥匙楼层选择 -->
                            <FormItem :label="$t('l.select_floor')"
                                      style="display: flex;align-items: center"
                                      class="key-form-item"
                                      :rules="{required: true, message: $t('l.remark45'), trigger: 'blur'}"
                                      :prop="'list.'+index+'.key.floors'">
                                <Select @on-change="onChangeSelect($event,index)" v-model="item.key.floors" size="small"
                                        filterable
                                        :placeholder="$t('l.select_floor')">
                                    <Option v-for="(floor,i) in item.deviceFloors" :key="i" :disabled="floor.disabled"
                                            :value="floor.id">{{floor.floorName}}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem class="key-form-item"
                                      :rules="{required: true, message: $t('l.remark46'), trigger: 'blur',type:'date'}"
                                      :prop="'list.'+index+'.key.end_time'"
                                      :label="$t('l.deadline')">
                                <DatePicker placement="top" type="date"
                                            :placeholder="$t('l.remark48')"
                                            v-model="item.key.end_time"></DatePicker>
                            </FormItem>
                            <FormItem class="key-form-item"
                                      :rules="{required: true, message:$t('l.remark49'), trigger: 'blur',type:'date'}"
                                      :prop="'list.'+index+'.key.limit_day'"
                                      :label="$t('l.remark50')">
                                <InputNumber type="number" size="small" :placeholder="$t('l.remark51')"
                                             v-model="item.key.limit_day"/>
                            </FormItem>
                            <FormItem class="key-form-item" :label="$t('l.face_lift')">
                                <Tooltip transfer :content="item.key.is_device.face==0?$t('l.open'):$t('l.close')"
                                         placement="top">
                                    <i-switch @on-change="changeFace($event,index)" style="margin-right: 10px"
                                              :value="item.key.is_device.face==0"
                                              size="small"></i-switch>
                                </Tooltip>
                            </FormItem>
                            <Button @click="close(index)">
                                <Icon type="md-close"/>
                            </Button>
                        </Form>
                    </div>
                </FormItem>
                <Row  class="margin-top-10 margin-left-10">
                    <Col span="24" v-if="showAddKeys">
                        <Button type="dashed" long icon="md-add" @click="add_key">{{$t('l.remark52')}}</Button>
                    </Col>
                </Row>
            </Form>
        </lg-modal>
        <!-- 授权 -->
        <lg-modal width="400" :title="$t('l.give_lift')" :show="empower.show" :loading="empower.loading"
                  @on-submit="empower_submit('empower')" @on-cancel="empower.loading=false; empower.show = false;">
            <Form label-position="top" :model="empower" ref="empower" :rules="getEmpowerRules">
                <FormItem :label="$t('l.community')">
                    <Input v-model="current_community.name" disabled/>
                </FormItem>
                <FormItem prop="chosedAdderss" :label="$t('l.build_unit')">
                    <Cascader
                            v-model="empower.chosedAdderss"
                            :data="locationTree"
                            change-on-select
                            @on-change="empowerLocation"
                            :placeholder="$t('l.build_unit')">
                    </Cascader>
                </FormItem>
                <FormItem prop="key.floors" :label="$t('l.select_floor')">
                    <Select @on-change="onChangeEmperSelect" size="small" v-model="empower.key.floors"
                            filterable :placeholder="$t('l.select_floor')">
                        <Option v-for="(item,index) in deviceList.locationFloors" :key="index" :value="item.id"
                                :disabled="item.disabled">{{item.floorName}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem prop="key.end_time" :label="$t('l.deadline')">
                    <DatePicker placement="top" transfer format="yyyy-MM-dd"
                                v-model="empower.key.end_time"
                                :placeholder="$t('l.deadline')">
                    </DatePicker>
                </FormItem>
                <FormItem prop="key.limit_day" :label="$t('l.remark50')">
                    <InputNumber v-model="empower.key.limit_day"/>
                </FormItem>
                <FormItem class="key-form-item" :label="$t('l.face_lift')">
                    <Tooltip transfer :content="empower.key.is_device.face==0?$t('l.open'):$t('l.close')"
                             placement="top">
                        <i-switch style="margin-right: 10px" :value="empower.key.is_device.face==0"
                                  @on-change="changeEmpowner" size="small"></i-switch>
                    </Tooltip>
                </FormItem>
            </Form>
        </lg-modal>
        <!-- 续期 -->
        <lg-modal width="910" :title="$t('l.owner_lift')" :show="renew.show" confirm-text="l.edit"
                  @on-submit="renew_submit"
                  @on-cancel="renew.loading=false; renew.show = false;">
            <Row type="flex" justify="start" style="align-content: center">
                <Col>
                    <!--<div class="face-data-img-box" style="background-color: #ccc" v-if="currentOwner.is_face_imgs!=1"></div>-->
                    <!--<div class="face-data-img-box" v-else>-->
                        <!--<img :src="currentOwner_head_url" alt=""/>-->
                    <!--</div>-->
                    <Avatar size="large" :src="currentOwner.is_face_imgs ?currentOwner.is_face_imgs :'https://static.diantiyun.com/upload/image/avatar.png?a=1'"/>
                </Col>
                <Col class="owner-data">
                    <p>ID：{{currentOwner.id}}</p>
                    <p>{{$t('l.name')}}：{{currentOwner.name}}</p>
                    <p>{{$t('l.mobile')}}：{{currentOwner.mobile}}</p>
                    <template>
                        <Row>
                            <Col span="10">
                                <Tag :color="currentOwner.is_face_imgs?'green':'volcano'">
                                    {{currentOwner.is_face_imgs==0?$t('l.face_no_collect'):$t('l.face_collected')}}
                                </Tag>
                            </Col>
                            <Col span="9">
                                <template>
                                    <Tag v-if="currentOwner.j_admin"
                                         :color="currentOwner.j_admin.includes(current_community.id)?'orange':'cyan'">
                                        {{currentOwner.j_admin.includes(current_community.id)?$t('l.property_manage'):$t('l.ordinary_owner')}}
                                    </Tag>
                                    <Tag v-else color="cyan">{{$t('l.ordinary_owner')}}</Tag>
                                </template>
                            </Col>
                            <Col span="5">
                                <Button @click="renew.showRole=!renew.showRole">
                                    <Icon type="md-list"/>
                                    {{$t('l.unfold')}}
                                </Button>
                            </Col>
                        </Row>
                        <!--<transition name="fade">-->
                        <Row class="margin-top-5" v-if="renew.showRole" type="flex" justify="space-between">
                            <span>{{$t('l.change_community_role')}}:</span>
                            <Poptip transfer word-wrap width="200" confirm :ok-text="$t('l.confirm')"
                                    :cancel-text="$t('l.cancel')" :title="$t('l.remark53')"
                                    @on-ok="()=>{if(currentOwner.j_admin) {currentOwner.j_admin.push(current_community.id)}else{currentOwner.j_admin=[];currentOwner.j_admin.push(current_community.id)}}">
                                <Col span="4">
                                    <Button :disabled="currentOwner.j_admin&&currentOwner.j_admin.includes(current_community.id)"
                                            type="primary">{{$t('l.property_manage')}}
                                    </Button>
                                </Col>
                            </Poptip>
                            <Poptip transfer confirm :ok-text="$t('l.confirm')" :cancel-text="$t('l.cancel')"
                                    :title="$t('l.remark54')"
                                    @on-ok="()=>{currentOwner.j_admin.forEach((re,i)=>{if (re == current_community.id){currentOwner.j_admin.splice(i,1)}})}">
                                <Col span="6">
                                    <Button class="margin-left-5"
                                            :disabled="!currentOwner.j_admin||!currentOwner.j_admin.includes(current_community.id)"
                                            type="primary">{{$t('l.ordinary_owner')}}
                                    </Button>
                                </Col>
                            </Poptip>
                        </Row>
                        <!--</transition>-->
                    </template>
                </Col>
            </Row>
            <Divider/>
            <Row>
                <div class="face-data" v-if="currentOwner.j_keys&&currentOwner.j_keys.length>0">
                    <div class="face-data-qrkey" v-for="(item,index) in currentOwner.j_keys" :key="index">
                        <qrKey v-if="!item.disabled&&item.location[0]==current_community.id"
                               @changeLimitDay="changeLimitDay"
                               @changeEndTime="changeEndTime"
                               @deleteKey="deleteKey"
                               @disabledQr="disabledQr"
                               @disabledFace="disabledFace"
                               :keyInfo="item"
                               :keys="keys"
                               :buildings="j_buildings">
                        </qrKey>
                    </div>
                </div>
                <div class="face-data" v-else>
                    <span>{{$t('l.lift_no_permission')}}</span>
                </div>
            </Row>
        </lg-modal>
    </base-page>
</template>

<script>
    import basePage from "../my-components/base-page"
    import util from "../../libs/util"
    import lgModal from "../my-components/lg-modal"
    import tablePoptip from '../my-components/table-poptip'
    import qrKey from './components/qr-key'
    import faceDataImgs from './components/face_data_imgs'
    import communityTree from './components/community-tree'

    export default {
        name: "page_owner",
        components: {
            basePage,
            lgModal,
            qrKey,
            communityTree
        },
        data() {
            // const validateMobile = (rule, value, callback) => {
            //     if (!(/^1[3456789]\d{9}$/.test(value))) {
            //         callback(new Error(this.$t('l.remark11')));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                showAddKeys: true,
                validateMobile: (rule, value, callback) => {
                    if (!(/^1[3456789]\d{9}$/.test(value))) {
                        callback(new Error(this.$t('l.remark11')));
                    } else {
                        callback();
                    }
                },
                baseURL: "https://static.diantiyun.com/",
                j_buildings: [],
                keys: [],
                current_community: {  //  当前操作小区
                    id: 0,
                    name: '',
                    qr_refresh_times: 0
                },
                screen: {
                    building: {
                        id: 0
                    },
                    unit: {
                        id: 0
                    }
                },
                tableData: {
                    columns: [],
                    data: [],  // 所有数据
                    page: {
                        current: 1,  // 当前页码
                        size: 24, // 每页个数
                        sizeOptions: [12, 18, 24],
                        total: 0,
                        sortKey: 'id',
                        sortMethod: 'desc',
                        keyword: ''
                    }, // 当前页
                    size: 12, // m每页大小
                    loading: false
                },
                modal: {
                    title: this.$t('l.owner_manage'),
                    show: false,
                    ifEdit: false, // 是否是编辑框
                    loading: false,
                    // index: 0,
                    owner: {
                        name: '',
                        mobile: '',
                        j_admin: [],
                        j_address: [],
                        openid: '',
                        insert_time: new Date().pattern("yyyy-MM-dd HH:mm:ss"),
                        disabled: 0,
                        j_keys: [],
                        remark: '',
                        is_face_imgs: 0,
                        last_time: 0
                    },
                    // chosedAdderss: [],
                    mailAddress: [{   // 通讯地址
                        disabled: false,
                        list: [],
                    }],
                },
                showChooesdAddress: [],// 编辑显示的地址
                modalKey: {
                    list: [], // 注册的钥匙
                    chosedFloors: []  //  已选中的楼层
                },
                empower: {
                    title: '',
                    show: false,
                    loading: false,
                    key: {
                        id: 0,
                        uuid: 0,
                        location: [],
                        end_time: "",
                        floors: 0,
                        // floorText:'',
                        limit_day: 0,
                        from_user: 0,
                        is_device: {
                            qr: 0,
                            face: 0
                        },
                        count: {
                            num: 1,
                            current_date: new Date().pattern("yyyy-MM-dd")
                        }
                    },
                    chosedAdderss: []
                },
                renew: {
                    title: '',
                    show: false,
                    showRole: false
                },
                search: '',
                deviceList: {
                    // list: [], // 对应位置  所有设备
                    locationFloors: [],  //  对应位置下的 所有楼层
                },
                expandNodes: [],
                activeLable: '',
                currentOwner: {},
                currentOwner_head_url: '#ccc',
                face_key_uuid: [],
                communitys: []
            }
        },
        methods: {
            change(id) {
                this.activeLable = ""
                this.screen.building.id = 0
                this.screen.unit.id = 0
                let community = this.communitys.find(item => (item.id == id));
                if (community) {
                    this.current_community.id = id
                    this.current_community.name = community.name
                    this.current_community.qr_refresh_times = community.qr_refresh_times
                    localStorage.setItem("current_community", JSON.stringify(this.current_community))
                    this.getBuilding(id);
                    this.getOwner();
                    return
                }
            },
            // empower_end_time(val){
            //     this.empower.key.end_time = val
            // },
            getBuilding(id) { // 获取 小区 楼宇单元树
                if (id) {
                    util.ajax.get('/community/getbyid?id=' + id).then(res => {
                        if (!res.code) {
                            this.j_buildings = util.parseJSON(res.data.j_buildings, [])
                            this.j_buildings.forEach(b => {
                                b.title = b.name;
                                b.type = "building";
                                b.lable = "building" + b.id
                                b.checked = false;
                                b.children = b.units || [];
                                b.children.forEach(u => {
                                    u.title = u.name;
                                    u.type = "unit";
                                    u.lable = "unit" + u.id
                                    u.checked = false;
                                    u.children = u.doors || [];
                                    u.children.forEach(d => {
                                        d.title = d.name;
                                        d.checked = false
                                        d.lable = "door" + d.id;
                                        d.type = "door";
                                    })
                                })
                            })
                        }
                    })
                }
            },
            onTreeSelect(root, node, data, activeLable) { // 选择节点
                if (activeLable) {
                    this.screen.building.id = 0
                    this.screen.unit.id = 0
                } else {
                    switch (data.type) {
                        case 'building':
                            this.screen.building.id = data.id
                            this.screen.unit.id = 0
                            break;
                        case 'unit':
                            this.screen.building.id = root[node.parent].node.id
                            this.screen.unit.id = data.id
                            break;
                    }
                }
                this.getOwner()
            },
            blur() {
                if (this.showAddKeys) { //业主注册
                    if (!this.modal.owner.mobile) return
                    this.modalKey.list = []
                    this.modal.loading = true;
                    util.ajax.get('/owner/getbymobile?mobile=' + this.modal.owner.mobile).then(res => {
                        if (res.data) {
                            let owner = this.parseJSONOwner(res.data);
                            if (owner.j_address.length) {
                                let comm = owner.j_address.find(item => {
                                    if (this.current_community.id == item.community.id) {
                                        return item;
                                    }
                                })
                                if (comm) {
                                    this.$Modal.confirm({
                                        title: this.$t('l.prompt'),
                                        okText: this.$t('l.yes'),
                                        cancelText: this.$t('l.no'),
                                        content: this.$t('l.mobile') + `:${owner.mobile}` + " " + this.$t('l.remark57'),
                                        onCancel: () => {
                                            this.modal.show = false
                                        },
                                        onOk: () => {
                                            owner.name = this.modal.owner.name
                                            this.modal.owner = owner
                                        },
                                    })
                                } else { // 不是 当前操作的小区
                                    owner.name = this.modal.owner.name
                                    this.modal.owner = owner
                                }
                            } else {
                                if (owner.j_keys.length) {
                                    let comm = owner.j_keys.find(item => {
                                        if (this.current_community.id == item.location[0]) {
                                            return item;
                                        }
                                    })
                                    if (comm) {
                                        this.$Modal.confirm({
                                            title: this.$t('l.prompt'),
                                            content: this.$t('l.mobile') + `:${owner.mobile}` + " " + this.$t('l.remark57'),
                                            onCancel: () => {
                                                this.modal.show = false
                                            },
                                            okText: this.$t('l.yes'),
                                            cancelText: this.$t('l.no'),
                                            onOk: () => {
                                                owner.name = this.modal.owner.name
                                                this.modal.owner = owner
                                            },
                                        })
                                    } else {
                                        owner.name = this.modal.owner.name
                                        this.modal.owner = owner
                                    }
                                } else {
                                    owner.name = this.modal.owner.name
                                    this.modal.owner = owner
                                }
                            }
                        }
                        this.modal.loading = false;
                    })
                }
            },
            parseJSONOwner(json) {
                Object.keys(json).forEach(key => {
                    if (key.startsWith("j") && !json[key]) json[key] = [];
                    if (key.startsWith("j") && typeof json[key] == "string") {
                        json[key] = JSON.parse(json[key]);
                    }
                })
                return json;
            },
            add(name) { // 添加业主 按钮
                if (!this.current_community.id) {
                    this.$Message.warning(this.$t('l.remark58'))
                    return
                }
                this.showAddKeys = true;//
                this.$refs[name].resetFields();
                this.modalKey.list = []
                this.modalKey.chosedFloors = []
                this.showChooesdAddress = []
                this.modal.show = true
                if (this.modal.owner.id) delete this.modal.owner.id // 新增业主不需要id
            },
            select(selection, row) {
                this.tableData.data[row.index]._checked = true
            },
            select_all(selection) {
                this.tableData.data.forEach(item => {
                    item._checked = true
                })
            },
            select_cancel(selection, row) {
                this.tableData.data[row.index]._checked = false
            },
            select_all_cancel(selection) {
                this.tableData.data.forEach(item => {
                    item._checked = false
                })
            },
            onToggleExpand(node) {
                if (node.expand) {
                    this.expandNodes.push(node.id);
                } else {
                    this.expandNodes.splice(this.expandNodes.indexOf(node.id), 1);
                }
            },
            pageSizeChange(val) {
                this.tableDate.page.size = val
                this.getOwner();
            },
            getOwner() {  //   根据位置   获取业主信息
                if (!this.current_community.id) {
                    this.$Message.warning(this.$t('l.remark58'))
                    return
                }
                var param = {
                    cid: this.current_community.id,
                    bid: this.screen.building.id,
                    uid: this.screen.unit.id,
                    page: this.tableData.page
                }
                this.tableData.loading = true
                util.ajax.post("/owner/list", param).then(res => {
                    if (!res.code) {
                        this.setPage(res.data)
                    }
                    this.tableData.loading = false
                })
            },
            setOption(value, selectedData) {
                if (!this.modal.owner.id) { // 注册
                    this.modal.owner.j_address = [];
                    this.modal.owner.j_address.push({
                        community: {id: this.current_community.id, name: this.current_community.name},
                        building: {id: selectedData[0].id, name: selectedData[0].name},
                        unit: {
                            id: selectedData[1] ? selectedData[1].id : 0,
                            name: selectedData[1] ? selectedData[1].name : ''
                        }
                    })
                } else { // 编辑
                    let buiding = this.locationTree.find(elem => {
                        return value[0] == elem.id;
                    })
                    let isExsitUnit = buiding.children.length;
                    let isEdit = this.showChooesdAddress.length // 是否时编辑操作
                    if (!isEdit) { // 不是编辑 添加新的地址
                        selectedData.map((elem, index, arr) => ({
                            community: {id: this.current_community.id, name: this.current_community.name},
                            building: {id: arr[0].id, name: arr[0].name},
                            unit: {id: arr[1] ? arr[1].id : 0, name: arr[1] ? arr[1].name : ''}
                        })).forEach(item => { // 新增地址
                            if (!isExsitUnit || (isExsitUnit && item.unit.id)) { // 这栋楼单元存在并且选择了单元
                                this.modal.owner.j_address.push(item)
                            }
                        })
                    } else {// 编辑操作 楼 单元
                        this.modal.owner.j_address[this.showChooesdAddress[2]] = {
                            community: {id: this.current_community.id, name: this.current_community.name},
                            building: {id: selectedData[0].id, name: selectedData[0].name},
                            unit: {
                                id: selectedData[1] ? selectedData[1].id : 0,
                                name: selectedData[1] ? selectedData[1].name : ''
                            }
                        };
                    }
                    let param = {};
                    if (this.modal.owner.j_address.length > 1) {
                        this.modal.owner.j_address.forEach(item => {
                            param[`${item.community.id}-${item.building.id}-${item.unit.id}`] = item
                        })
                        if (param) {
                            let arr = []
                            Object.keys(param).forEach(elem => {
                                arr.push(param[elem])
                            })
                            this.modal.owner.j_address = arr;
                        }
                    }
                }
            },
            // 去重 this.modal.owner.j_address
            onLocationSelectKey(val, data, index) {
                this.modalKey.list[index].key.floors = "" // 清除上一次所选楼层
                this.modalKey.list[index].deviceFloors = []
                let local = this.locationTree.find(local => (val[0] == local.id)); // 楼宇结构
                if (local) {
                    if (local && local.children && local.children.length && val.length > 1) {
                        this.modalKey.list[index].key.location.splice(1, 1, val[0])
                        this.modalKey.list[index].key.location.splice(2, 1, val[1])
                        this.getDeviceByLocation(this.current_community.id, val[0], val[1], index);
                    } else {
                        this.modalKey.list[index].key.location.splice(1, 1, val[0]) // 楼id
                        this.modalKey.list[index].key.location.splice(2, 1, 0) // 单元id
                        this.getDeviceByLocation(this.current_community.id, val[0], 0, index);
                    }
                }
            },
            empowerLocation(val, selectedData) {
                this.deviceList.locationFloors = []
                this.empower.key.floors = ""
                let local = this.locationTree.find(local => (val[0] == local.id));
                this.empower.key.location.splice(0, 1, this.current_community.id)
                if (local) {
                    if (local.children && local.children.length && val.length > 1) {
                        this.empower.key.location.splice(1, 1, selectedData[0].id)
                        this.empower.key.location.splice(2, 1, selectedData[1].id)
                        this.getDeviceByLocation(this.current_community.id, val[0], val[1], -1);
                    } else if (!local.children || !local.children.length) {
                        this.empower.key.location.splice(1, 1, selectedData[0].id)
                        this.empower.key.location.splice(2, 1, 0)
                        this.getDeviceByLocation(this.current_community.id, val[0], 0, -1);
                    }
                }
            },
            getDeviceByLocation(cid, bid, uid, index) {
                // this.deviceList.list = [] // 设备列表
                // index   第几把钥匙  = 0则为注册添加  -1则为授权
                util.ajax.get('/owner/devices', {
                    params: {
                        cid: cid, bid: bid, uid: uid
                    }
                }).then(res => {
                    if (!res.code) {
                        // this.deviceList.list = res.data;//
                        let deviceinfo = res.data;
                        if (deviceinfo) {
                            // let deviceinfo = this.deviceList.list.find(item => {
                            //     let location = JSON.parse(item.j_location)
                            //     if (uid) return location.building.id == bid && location.unit.id == uid;
                            //     else return location.building.id == bid;
                            // })
                            // let deviceinfo = this.deviceList.list[0];
                            if (index >= 0) { // 添加业主
                                this.modalKey.list[index].key.uuid = deviceinfo.qr_id;
                                //  this.modalKey.list[index].key.uuid= typeof deviceinfo.qr_id === "string" ? parseInt(deviceinfo.qr_id) : deviceinfo.qr_id
                            } else { // 授权
                                // this.empower.key.uuid = typeof deviceinfo.qr_id === "string" ? parseInt(deviceinfo.qr_id) : deviceinfo.qr_id
                                this.empower.key.uuid = deviceinfo.qr_id
                            }
                            let list = JSON.parse(deviceinfo.j_floors).display;
                            let is_through_door = typeof deviceinfo.device_param === 'string' ? JSON.parse(deviceinfo.device_param).is_through_door : deviceinfo.device_param.is_through_door
                            if (list) { // 楼层显示
                                if (is_through_door) {    //贯通
                                    let num = list.length / 2;
                                    list.forEach((f, i) => {// 授权
                                        let p = {}
                                        if (i >= num) {
                                            p = {floorName: f, id: (i - num) + 33 + "", disabled: false}
                                        } else {
                                            p = {floorName: f, id: (i + 1) + "", disabled: false}
                                        }
                                        if (index != -1) { // 非授权
                                            this.modalKey.list[index].deviceFloors.push(p)
                                        } else {
                                            this.deviceList.locationFloors.push(p)
                                        }
                                    })
                                } else {//  非贯通
                                    list.forEach((f, i) => {
                                        var p = {floorName: f, id: (i + 1) + "", disabled: false}
                                        if (index != -1) {// 非授权
                                            this.modalKey.list[index].deviceFloors.push(p)
                                        } else {
                                            this.deviceList.locationFloors.push(p)
                                        }
                                    })
                                }
                                if (index != -1) {  //非授权的添加业主操作 判断是否是新添加还是原来已经有
                                    if (this.modalKey.chosedFloors[index]) delete this.modalKey.chosedFloors[index]
                                    if (this.modal.owner.j_keys.length) {
                                        this.modal.owner.j_keys.forEach(key => {
                                            this.modalKey.list[index].deviceFloors.forEach(fl => {
                                                // 如果之前选择过当前楼层  不让继续选择
                                                if (key.location[0] == this.current_community.id && fl.id == key.floors && key.location[1] == bid && uid == key.location[2]) {
                                                    fl.disabled = true
                                                }
                                            })
                                        })
                                    } else {
                                        // 一把钥匙没有正在添加
                                        if (this.modalKey.chosedFloors && this.modalKey.list[index].deviceFloors.length) {
                                            // this.modalKey.chosedFloors.forEach(f=>{
                                            this.modalKey.list[index].deviceFloors.forEach(fl => {
                                                if (this.modalKey.chosedFloors.includes(fl.id)) {
                                                    fl.disabled = true
                                                }
                                            })
                                            // })
                                        }
                                    }
                                } else {     // 执行授权操作
                                    if (this.currentOwner.j_keys.length && this.deviceList.locationFloors.length) {
                                        this.currentOwner.j_keys.forEach(floor => {
                                            this.deviceList.locationFloors.forEach(fl => {
                                                // 小区相同 楼相同 单元相同 floor相同 变为true
                                                if (floor.location[0] == this.current_community.id && fl.id == floor.floors && floor.location[1] == bid && uid == floor.location[2]) {
                                                    fl.disabled = true
                                                }
                                            })
                                        })
                                    }
                                }
                            }
                        } else {
                            this.$Message.warning(this.$t('l.remark59'))
                        }
                    } else {
                        this.$Message.warning(this.$t('l.remark60'))
                    }
                })
            },
            onChangeSelect(v, i) {
                if (v) {
                    let item = this.modalKey.list[i].deviceFloors.find(re => {
                        return re.id == v;
                    });
                    this.modalKey.list[i].key.floorText = item.floorName;
                    this.modalKey.chosedFloors.push(item.id);
                }
            },
            onChangeEmperSelect(v) {
                if (v) {
                    let item = this.deviceList.locationFloors.find(re => {
                        return re.id == v;
                    });
                    this.empower.key.floorText = item.floorName;
                }
            },
            onSubmit(name1, name2) { // 提交表单
                this.$refs[name1].validate(valid => {
                    if (valid) {
                        let owner = util.deepCopy(this.modal.owner)
                        if (!this.showAddKeys) { // 编辑模式下 的提交
                            this.modal.loading = true;
                            util.ajax.post('/owner/update', {
                                owner: owner,
                            }).then(res => {
                                if (!res.code) {
                                    this.renew.showRole = !this.renew.showRole
                                    this.modal.show = false;
                                    this.modal.loading = false;
                                    this.getOwner()
                                    this.$Message.success(this.$t('l.edit_success'))
                                } else {
                                    this.$Message.success(this.$t('l.edit_fail'))
                                }
                            })
                        }
                        else {// 添加 业主
                            if (this.modalKey.list.length) {
                                this.$refs[name2][0].validate((valid2) => {
                                    if (valid2) {
                                        let list = []
                                        let len = owner.j_keys.length
                                        this.modal.loading = true;
                                        this.modalKey.list.forEach((item, index) => {
                                            item.key.from_user = this.$store.state.user.user.id
                                            item.key.id = len ? len + index + 1 : index + 1;
                                            if (!item.key.is_device.face) {
                                                list.push(item.key.uuid)
                                            }
                                            this.face_key_uuid = util.unique(list);
                                            let end_time = new Date(item.key.end_time).pattern("yyyy-MM-dd");
                                            let new_key = JSON.parse(JSON.stringify(item.key));
                                            new_key.end_time = end_time;
                                            owner.j_keys.push(new_key);
                                        })
                                        this.addOwner(owner);
                                    } else {
                                        this.modal.loading = false;
                                        this.$Message.error(this.$t('l.remark24'));
                                        return;
                                    }
                                })
                            } else {
                                if (this.modal.owner.j_address.length) { // 如果当前业主 在当前小区内没有钥匙并且没有通讯地址
                                    let findOwner = this.modal.owner.j_address.find(elem => {
                                        return this.current_community.id == elem.community.id
                                    })
                                    if (findOwner) { // 找到当前小区 ，说明可以添加
                                        this.addOwner(owner);
                                        // this.face_key_uuid = []
                                        return
                                    }
                                }
                                this.$Message.warning(this.$t('l.remark61'));
                                return
                            }
                            this.face_key_uuid = []
                        }
                    } else {
                        this.modal.loading = false;
                        this.$Message.error(this.$t('l.remark24'));
                        return;
                    }
                })
            },
            addOwner(owner) {
                util.ajax.post('/owner/add', {
                    owner: owner,
                    face_key_uuid: this.face_key_uuid,
                }).then(res => {
                    if (!res.code) {
                        this.getOwner();
                        this.$Message.success(this.$t('l.add_success'));
                    } else {
                        this.$Message.error(this.$t('l.add_fail'));
                    }
                    this.modal.show = false;
                    this.modal.loading = false;
                })
            },
            empower_submit(name) { // 业主授权权限
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.currentOwner.j_keys) {
                            this.empower.key.id = util.orderKeys(this.currentOwner.j_keys).length + 1
                        } else {
                            this.empower.key.id = 1
                        }
                        this.empower.key.from_user = this.$store.state.user.user.id
                        let end_time = new Date(this.empower.key.end_time).pattern("yyyy-MM-dd");
                        this.empower.key.end_time = end_time;
                        let key = JSON.parse(JSON.stringify(this.empower.key))
                        key.end_time = end_time;
                        this.empower.show = false
                        util.ajax.post('/owner/empower', {
                            id: this.currentOwner.id,
                            key: key
                        }).then(res => {
                            if (!res.code) {
                                this.getOwner()
                                this.$Message.success(this.$t('l.authorize_success'));
                            } else {
                                this.$Message.success(this.$t('l.authorize_fail'));
                            }
                        })
                    } else {
                        this.$Message.error(this.$t('l.remark24'));
                    }
                })
            },
            deleteKey(key) {
                this.$Modal.confirm({
                    title: this.$t('l.warn'),
                    content: this.$t('l.remark62'),
                    onOk: () => {
                        let key_id = key.id
                        util.ajax.post('/owner/deletekey', {
                            owner_id: this.currentOwner.id,
                            key_id: key_id,
                        }).then(res => {
                            if (!res.code) {
                                this.$Message.success(this.$t('l.delete_success'))
                                this.getOwner();
                            } else {
                                this.$Message.success(res.msg)
                            }
                            this.renew.show = false
                        })
                    }
                })
            },
            changeFace(val, index) {
                if (!val) this.modalKey.list[index].key.is_device.face = 1
            },
            disabledQr(val, key) {
                if (this.currentOwner.j_keys) {
                    this.currentOwner.j_keys.forEach(item => {
                        if (val) {
                            if (item.id == key.id) item.is_device.qr = 0
                        } else {
                            if (item.id == key.id) item.is_device.qr = 1
                        }
                    })
                }
            },
            disabledFace(val, key) {
                this.currentOwner.j_keys.forEach(item => {
                    if (item.id == key.id) {
                        let uuid = item.uuid
                        this.face_key_uuid.push(uuid)
                        if (val) {
                            item.is_device.face = 0
                        } else {
                            item.is_device.face = 1
                        }
                    }
                })
            },
            refresh() {
                if (!this.current_community.id) {
                    this.$Message.warning(this.$t('l.remark58'))
                    return
                }
                this.getOwner();
            },
            close(index) {
                this.modalKey.list.splice(index, 1)
                delete this.modalKey.chosedFloors[index]
            },
            add_key() {
                var addkey = {
                    key: {
                        id: 0,
                        uuid: 0,
                        location: [this.current_community.id],
                        end_time: '',
                        floors: 0,
                        // floorText: '',
                        limit_day: this.current_community.qr_refresh_times, // 根据小区
                        from_user: 0,
                        is_device: {qr: 0, face: 0},
                        count: {
                            num: 1,
                            current_date: new Date().pattern("yyyy-MM-dd")
                        }
                    },
                    chosedAddressKey: [],
                    deviceFloors: [] // 当前设备对应的楼层信息
                }
                this.modalKey.list.push(addkey)
            },
            changeEndTime(key, date) {
                var list = []
                if (this.currentOwner.j_keys) {
                    this.currentOwner.j_keys.forEach((item, index) => {
                        if (key.id == item.id) {
                            item.end_time = date
                            if (!item.is_device.face) {
                                list.push(item.uuid)
                            }
                        }
                    })
                }
                this.face_key_uuid = util.unique(list);
            },
            changeLimitDay(key, val) {
                if (this.currentOwner.j_keys) {
                    this.currentOwner.j_keys.forEach((item, index) => {
                        if (key.id == item.id) {
                            item.limit_day = val
                            return
                        }
                    })
                }
            },
            renew_submit() {
                this.face_key_uuid = util.unique(this.face_key_uuid)
                let new_keys = []
                this.currentOwner.j_keys.forEach(key => {
                    let end_time = new Date(key.end_time).pattern("yyyy-MM-dd");
                    let new_key = JSON.parse(JSON.stringify(key));
                    new_key.end_time = end_time;
                    new_keys.push(new_key);
                })
                this.currentOwner.j_keys = new_keys;
                util.ajax.post('/owner/renew', {
                    owner: this.currentOwner,
                    face_key_uuid: this.face_key_uuid
                }).then(res => {
                    if (!res.code) {
                        this.$Message.success(this.$t('l.edit_success'))
                        this.refresh();
                    } else {
                        this.$Message.success(this.$t('l.edit_fail'))
                    }
                })
                this.renew.show = false
                this.face_key_uuid = []
            },
            return_owner(ow) { //  返回业主对象
                var owner = {}
                owner = util.deepCopy(ow)
                owner.j_address = ow.j_address ? typeof ow.j_address == 'string' ? JSON.parse(ow.j_address) : ow.j_address : [];
                owner.j_keys = ow.j_keys ? typeof ow.j_keys == 'string' ? JSON.parse(ow.j_keys) : ow.j_keys : [];
                owner.j_admin = ow.j_admin ? typeof ow.j_admin == 'string' ? JSON.parse(ow.j_admin) : ow.j_admin : [];
                delete owner.index
                delete owner._checked
                delete owner._index
                delete owner._rowKey
                return owner
            },
            formatFunc(date) {
                if (date) {
                    return date.substring(0, 4) + date.substring(5, 7);
                }
                return "";
            },
            searchBlur() {
                if (!this.tableData.page.keyword) this.getOwner();
            },
            changeEmpowner(v) {
                if (!v) this.empower.key.is_device.face = 1
            },
            setPage(pageInfo) {
                if (pageInfo) {
                    pageInfo.list.forEach((owner, index) => {
                        util.parseJSONResult(owner);
                        owner.index = index
                    })
                    this.tableData.data = pageInfo.list;
                    if (pageInfo.pageNumber) this.tableData.page.current = pageInfo.pageNumber;
                    if (pageInfo.totalRow) this.tableData.page.total = pageInfo.totalRow;
                }
            },
            deleteOwner(id) {
                var cid = JSON.parse(localStorage.getItem("current_community")).id
                var that = this
                this.$Modal.confirm({
                    title: this.$t('l.warn'),
                    content: this.$t('l.remark63'),
                    okText: that.$t('l.confirm'),
                    cancelText: that.$t('l.cancel'),
                    onOk: function () {
                        util.ajax.get('owner/deleteowner', {
                            params: {
                                id: id,
                                cid: cid
                            }
                        }).then(res => {
                            if (!res.code) {
                                this.$Message.success(that.$t('l.delete_success'));
                                that.getOwner();
                            }
                            else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                })
            },
            loadCommunitys() {
                util.ajax.get("/community/getlist").then(res => {
                    this.communitys = res.data;
                    return res.data;
                }).then(() => {
                    if (localStorage.getItem("current_community")) {
                        this.current_community = JSON.parse(localStorage.getItem("current_community"))
                    } else { // 不存在 永远选择第一个
                        if (this.communitys && this.communitys.length) {
                            this.current_community.id = this.communitys[0].id
                            this.current_community.name = this.communitys[0].name
                        }
                        localStorage.setItem("current_community", JSON.stringify(this.current_community))
                    }
                    this.getBuilding(this.current_community.id);
                    this.getOwner();
                })
            },
            changeOwnerIsAdmin(v) {
                if (v) {
                    this.modal.owner.j_admin.push(this.current_community.id)
                } else {
                    this.modal.owner.j_admin.forEach((re, i) => {
                        if (re == this.current_community.id) {
                            this.modal.owner.j_admin.splice(i, 1);
                            return;
                        }
                    })
                }
            },
        },
        computed: {
            getEmpowerRules() {
                return {
                    chosedAdderss: [{required: true, message: this.$t('l.remark33'), trigger: 'blur', type: "array"}],
                    'key.floors': [{
                        required: true,
                        message: this.$t('l.remark33'),
                        trigger: 'blur',
                    }],
                    'key.end_time': [{required: true, message: this.$t('l.remark33'), trigger: 'blur', type: 'date'}],
                    'key.limit_day': [{
                        required: true,
                        message: this.$t('l.remark33'),
                        trigger: 'blur',
                        type: "number",
                        min: 1
                    }],
                }
            },
            getFormRules() {
                return {
                    'owner.name': [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
                    'owner.mobile': [{
                        required: true,
                        message: this.$t('l.remark33'),
                        trigger: 'blur'
                    }, {validator: this.validateMobile, trigger: 'blur'}],
                    mailAddress: [{
                        required: true,
                        message: this.$t('l.remark56'),
                        trigger: 'blur',
                        type: 'array',
                        min: 2
                    }]
                }
            },
            getColumns() {
                return [
                    {
                        title: this.$t('l.name'),
                        key: "name",
                        width: '120',
                        align: "center",
                    },
                    {
                        title: this.$t('l.mobile'),
                        key: "mobile",
                        width: '130',
                        align: "center",
                    },
                    {
                        title: this.$t('l.address'),
                        key: "address",
                        align: "center",
                        render: (h, params) => {
                            return h(tablePoptip, {
                                props: {
                                    data: params.row,
                                    communityId: this.current_community.id
                                },
                                on: {
                                    edit: (index) => {
                                        this.modal.owner = this.return_owner(params.row)
                                        let j_address = this.modal.owner.j_address[index];
                                        this.showChooesdAddress = []
                                        this.showChooesdAddress.push(...[j_address.building.id, j_address.unit.id, index])
                                        this.showAddKeys = false;
                                        this.modal.show = true
                                    },
                                    delete: (owner) => {
                                        let o = this.return_owner(params.row)
                                        if (o.j_address.length) {
                                            o.j_address.forEach((i, index) => {
                                                if (i.community.id == this.current_community.id
                                                    && i.building.id == owner.location.building.id
                                                    && i.unit.id == owner.location.unit.id) {
                                                    this.$Modal.confirm({
                                                        title: this.$t('l.warn'),
                                                        content: this.$t('l.remark55'),
                                                        okText: this.$t('l.confirm'),
                                                        cancelText: this.$t('l.cancel'),
                                                        onOk: () => {
                                                            o.j_address.splice(index, 1)
                                                            util.ajax.post("/owner/update", {owner: o}).then(res => {
                                                                if (!res.code) {
                                                                    this.$Message.success(this.$t('l.delete_success') + "!")
                                                                    this.getOwner();
                                                                } else {
                                                                    this.$Message.error(this.$t('l.delete_fail') + "!")
                                                                }
                                                            })
                                                        }
                                                    })
                                                    return
                                                }
                                            })
                                        }
                                    },
                                    addAddress: () => { // 添加新地址
                                        this.showChooesdAddress = []
                                        this.modalKey.list = []
                                        this.showAddKeys = false;
                                        this.modal.show = true
                                        this.modal.owner = this.return_owner(params.row)
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('l.entry_time'),
                        key: "insert_time",
                        align: "center",
                        // width:170
                    },
                    {
                        title: this.$t('l.operation'),
                        key: "action",
                        fixed: 'right',
                        align: "center",
                        render: (h, params) => {
                            let actionBtns = [];
                            if (this.$ifauth('fun_empower')) actionBtns.push(h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.empower.resetFields();
                                        this.currentOwner = this.return_owner(params.row)
                                        this.empower.key.limit_day = this.current_community.qr_refresh_times
                                        this.empower.show = true
                                    },
                                }
                            }, this.$t('l.authorize')));

                            if (this.$ifauth('fun_edit_owner')) actionBtns.push(h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        util.ajax.get("owner/get", {
                                            params: {id: params.row.id}
                                        }).then(res => {
                                            this.renew.show = true
                                            this.currentOwner = this.return_owner(res);
                                            if (this.currentOwner.is_face_imgs == 1) {
                                                this.currentOwner_head_url = this.baseURL + 'upload/face_features/' + this.formatFunc(this.currentOwner.insert_time) + '/imgs/' + this.currentOwner.mobile + '.jpg?m=' + Math.random();
                                            }
                                        })

                                    }
                                }
                            }, this.$t('l.check') + '/' + this.$t('l.edit')));

                            if (this.$ifauth('fun_del_owner')) actionBtns.push(h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.deleteOwner(params.row.id);
                                    }
                                }
                            }, this.$t('l.delete')));

                            actionBtns.push(h(faceDataImgs, {
                                props: {
                                    is_face_imgs: params.row.is_face_imgs
                                },
                                style: {
                                    marginLeft: '8px',
                                    cursor: 'pointer',
                                    display: '-webkit-inline-box'
                                }
                            }));
                            return h('ButtonGroup', actionBtns)
                        }
                    },
                ]
            },
            locationTree() {
                let list = []
                this.j_buildings.forEach(b => {
                    b.value = b.id;
                    b.type = 'building'
                    b.label = b.name;
                    b.children = b.units;
                    b.units.forEach(u => {
                        u.value = u.id;
                        u.type = 'unit'
                        u.label = u.name;
                        u.children = u.doors;
                        // u.doors.forEach(d => {
                        //     d.value = d.id;
                        //     d.type = 'door'
                        //     d.label = d.name;
                        // })
                    })
                    list.push(b)
                })
                return list;
            },
        },
        activated() {
            this.loadCommunitys();
        },
    }
</script>

<style scoped lang="less">
    .key-form {
        border: 1px solid #f2dede;
        border-radius: 4px;
        padding: 6px;
        position: relative;
        margin-bottom: 24px;
        Button {
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }

    .row {
        font-weight: 600;
        color: #515a6e;
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    .pane-left {
        width: 20%;
        &-select {
            width: 70%;
        }
    }

    .batch-box {
        z-index: 9;
        min-height: 120px;
        max-height: 600px;
        background-color: white;
        overflow: hidden;
        overflow-y: auto;
        -webkit-box-shadow: 0 0 5px #ddd;
        box-shadow: 0 0 5px #ddd;
        border-radius: 4px 0 4px 4px;
        border: 1px solid #333;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .face-data-img-box {
        width: 100px;
        height: 100px;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 50%;
        border: 1px solid #1e90ff;
        display: flex;
        justify-content: center;
        align-content: center;
        background-repeat: round;
    }

    .face-data-img-box img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
    }

    .owner-data {
        margin-left: 20px;
        font-size: 16px;
        font-weight: 500;
    }

    .face-data {
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
        max-height: 400px;
        overflow-y: auto;
    }
</style>